'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Divider from '@enlighten/design-system/dist/Divider';
import Grid from '@enlighten/design-system/dist/Grid';
import List from '@enlighten/design-system/dist/List';
import ListItem from '@enlighten/design-system/dist/ListItem';
import ListItemText from '@enlighten/design-system/dist/ListItemText';
import Typography from '@enlighten/design-system/dist/Typography';
import * as HomeIcon1Component from '../../assets/images/finance/home-section2-icon-1.svg';
import * as HomeIcon2Component from '../../assets/images/finance/home-section2-icon-2.svg';
import * as HomeIcon3Component from '../../assets/images/finance/home-section2-icon-3.svg';
import * as KingIcon1Component from '../../assets/images/finance/king-section2-icon-1.svg';
import * as KingIcon2Component from '../../assets/images/finance/king-section2-icon-2.svg';
import * as KingIcon3Component from '../../assets/images/finance/king-section2-icon-3.svg';
const HomeIcon1 = process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true'
    ? HomeIcon1Component.default
    : HomeIcon1Component.ReactComponent;
const HomeIcon2 = process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true'
    ? HomeIcon2Component.default
    : HomeIcon2Component.ReactComponent;
const HomeIcon3 = process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true'
    ? HomeIcon3Component.default
    : HomeIcon3Component.ReactComponent;
const KingIcon1 = process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true'
    ? KingIcon1Component.default
    : KingIcon1Component.ReactComponent;
const KingIcon2 = process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true'
    ? KingIcon2Component.default
    : KingIcon2Component.ReactComponent;
const KingIcon3 = process.env.NEXT_PUBLIC_IS_NEXT_JS === 'true' ||
    process.env.NEXT_PRIVATE_IS_NEXT_JS === 'true'
    ? KingIcon3Component.default
    : KingIcon3Component.ReactComponent;
const list = [
    {
        img: {
            home: HomeIcon1,
            king: KingIcon1,
        },
        title: 'PF',
        descriptions: [
            { label: '사업 규모', value: '1MW 이상' },
            { label: '사업 규모', value: '임대,소유 모두 가능' },
            { label: '대출 규모', value: '사업비의 90%' },
            { label: '상환 기간', value: '14 ~ 17년' },
            { label: '담보', value: '발전소 현금흐름 담보' },
            { label: '연대 보증', value: '불필요' },
        ],
        footerDescription: `- 대출금 상환 후 수익 극대화
- 소규모 자본으로 대규모 사업가능
- 태양광 연계 ESS 리파이낸싱`,
    },
    {
        img: {
            home: HomeIcon2,
            king: KingIcon2,
        },
        title: '브리지론',
        descriptions: [
            { label: '사업 규모', value: '300kW ~ 1MW' },
            { label: '사업 규모', value: '소유' },
            { label: '대출 규모', value: '사업비의 50 ~ 60%' },
            { label: '상환 기간', value: '3~6 개월' },
            { label: '담보', value: '토지 근저당, 지상권 담보' },
            { label: '연대 보증', value: '상황에 따라 다름' },
        ],
        footerDescription: `- 3~6개월 단기간 사용
- 실질금리 월 1~2%선
- 시설자금대출 등 상환재원 필요`,
    },
    {
        img: {
            home: HomeIcon3,
            king: KingIcon3,
        },
        title: '시설자금대출',
        descriptions: [
            { label: '사업 규모', value: '1MW이하' },
            { label: '사업 규모', value: '소유' },
            { label: '대출 규모', value: '사업비의 60 ~ 80%' },
            { label: '상환 기간', value: '10 ~ 15년' },
            { label: '담보', value: '토지, 시설물 담보' },
            { label: '연대 보증', value: '사업주 연대 보증 필요' },
        ],
        footerDescription: `- REC 현물거래 가능
- 준공 후 자금 지급`,
    },
];
export default function FinanceSection2({ type }) {
    return (_jsx(Grid, { container: true, justifyContent: "center", bgcolor: "grey.100", width: "100%", children: _jsxs(Grid, { container: true, direction: "column", alignItems: "center", width: "100%", marginX: "auto", padding: { xs: '60px 24px', md: '100px 16px 140px' }, children: [_jsx(Typography, { fontSize: { xs: 22, md: 28 }, fontWeight: 700, textAlign: "center", children: "\uAE08\uC735\uC790\uBB38\uC758 \uB2E4\uC591\uD55C \uBC29\uBC95" }), _jsx(Typography, { fontSize: 16, fontWeight: 400, textAlign: "center", lineHeight: 1.5, marginBottom: 5, children: "\uC0AC\uC5C5\uC758 \uD2B9\uC131\uC5D0 \uB9DE\uAC8C \uAE08\uC735 \uAD6C\uC870\uB97C \uC124\uACC4\uD569\uB2C8\uB2E4." }), _jsx(Grid, { container: true, direction: { xs: 'column', md: 'row' }, justifyContent: "center", gap: 2, width: "100%", paddingX: { xs: 0, md: 1 }, children: list.map(({ img, title, descriptions, footerDescription }, i) => {
                        const Img = img[type];
                        return (_jsxs(Grid, { container: true, direction: "column", flex: 1, alignItems: "center", bgcolor: "common.white", width: "100%", maxWidth: { xs: '100%', md: 318 }, borderColor: "grey.300", borderRadius: "6px", padding: 5, sx: {
                                borderWidth: 1,
                                borderStyle: 'solid',
                            }, children: [_jsx(Grid, { display: "flex", justifyContent: "center", alignItems: "center", width: 150, height: 150, children: _jsx(Img, {}) }), _jsx(Typography, { fontSize: 18, fontWeight: 700, color: "primary", marginBottom: "50px", children: title }), _jsx(List, { sx: {
                                        width: '100%',
                                        padding: 0,
                                        '.MuiListItem-root': {
                                            height: 40,
                                            padding: '0 0 14px 0',
                                            '.MuiListItemText-root': {
                                                margin: 0,
                                                '.MuiTypography-root': {
                                                    fontSize: 14,
                                                    color: 'grey.700',
                                                },
                                            },
                                            '.MuiListItemSecondaryAction-root': {
                                                position: 'initial',
                                                fontSize: 16,
                                            },
                                        },
                                    }, children: descriptions.map(({ label, value }, j) => (_jsx(ListItem, { secondaryAction: value, children: _jsx(ListItemText, { children: label }) }, j))) }), _jsx(Divider, { sx: {
                                        width: '100%',
                                        marginY: 3,
                                        opacity: 1,
                                        borderColor: '#0000000F',
                                    } }), _jsx(Grid, { container: true, marginBottom: 2, children: _jsx(Typography, { fontSize: 16, lineHeight: 1.5, color: "grey.700", height: 72, children: footerDescription }) })] }, i));
                    }) })] }) }));
}
